import { render, staticRenderFns } from "./psyDetail.vue?vue&type=template&id=6dc1f33e&scoped=true&"
import script from "./psyDetail.vue?vue&type=script&lang=js&"
export * from "./psyDetail.vue?vue&type=script&lang=js&"
import style0 from "./psyDetail.vue?vue&type=style&index=0&id=6dc1f33e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc1f33e",
  null
  
)

export default component.exports